import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import Abas from '../../../../components/Abas';
import { useSnackBar } from '../../../../hooks/snackBar';
import FormEmpresaSeller from '../DadosCadastrais/FormEmpresaSeller';
import CdSeller from '../CadastrosCd';
import FormCdSeller from '../CadastrosCd/FormCdSeller'
import FormFilialSeller from '../Filial/FormFilial'
import FilialSeller from '../Filial'
import UsuarioSeller from '../UsuarioSeller'
import UsuarioSellerForm from '../UsuarioSeller/UsuarioSellerForm'
import RemuneracaoSeller from '../RemuneracaoGreeners/RemuneracaoSellerForm'
import CategoriaProduto from '../CategoriaProduto'
import ProdutoForm from '../CategoriaProduto/ProdutoForm'
import ImportacaoProduto from '../CategoriaProduto/ImportarProdutos'

import './styles.scss';

const listAbas = [
    { nome: 'Dados Cadastrais', id: 1 },
    { nome: 'Cadastros Filiais/CDs', id: 2 },
   /*  { nome: 'Cadastros Filiais', id: 3 }, */
    // { nome: 'Categorias de Produto', id: 4 },
    { nome: 'Usuários', id: 5 },
    { nome: 'Remuneração Greeners', id: 6 },
]


const SellerAbas = () => {
    const { idEmpresa } = useParams();
    const { addSnackBar } = useSnackBar();
    const [abaActive, setAbaActive] = useState(1);
    const [idEdit, setidEdit] = useState(null);

    const selectAba = (abaId, id = null) => {
        if (abaId != 1 && (idEmpresa === null || idEmpresa == undefined)) {
            setAbaActive(1);
            addSnackBar({
                message: 'Finalize o cadastro inicial ou selecione um Seller já cadastrado.',
                info: 'warning',
                open: true
            });
        } else {
            setAbaActive(abaId);
            setidEdit(id);
        }

    }

    const carregar = (abaId, id) => {
        switch (abaId) {
            case 1:
                return (<FormEmpresaSeller />)
            case 2:
                return (<CdSeller subSellerPage={selectAba} />)
            case 'formulario-cd':
                return (<FormCdSeller id={id} subSellerPage={selectAba} />)
            case 'editar-cd':
                return (<FormCdSeller id={id} subSellerPage={selectAba} />)
            case 3:
                return (<FilialSeller subSellerPage={selectAba} />)
            case 'formulario-filial':
                return (<FormFilialSeller id={id} subSellerPage={selectAba} />)
            case 'editar-filial':
                return (<FormFilialSeller id={id} subSellerPage={selectAba} />)
            case 4:
                return (<CategoriaProduto id={id} subSellerPage={selectAba} />)
            case 'formulario-produto':
                return (<ProdutoForm subSellerPage={selectAba} />)
            case 'editar-produto':
                return (<ProdutoForm id={id} subSellerPage={selectAba}  />)
            case 'importacao-produto':
                return (<ImportacaoProduto subSellerPage={selectAba}></ImportacaoProduto>)
            case 5:
                return (<UsuarioSeller subSellerPage={selectAba} />)
            case 'formulario-usuario-seller':
                return (<UsuarioSellerForm id={id} subSellerPage={selectAba} />)
            case 'editar-usuario-seller':
                return (<UsuarioSellerForm id={id} subSellerPage={selectAba} />)
            case 6:
                return (<RemuneracaoSeller subSellerPage={selectAba} />)

        }
    }

    return (
        <div>
            <div className="row">
                <span className="col-sm-3 col-md-3 col-lg-3 titulo">Sellers</span>
            </div>
            <div className='row negative-margin ml-1'>
                <strong>Detalhe</strong>
            </div>
            <div className="row abas mt20">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <Abas
                        abas={listAbas}
                        active={abaActive}
                        action={selectAba}
                    />
                </div>
            </div>
            <div>
                {
                    carregar(abaActive, idEdit)
                }
            </div>
        </div>
    )
}

export default SellerAbas;